// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./components/LoginPage";
import AdminDashboard from "./components/AdminDashboard";
import AreaDashboard from "./components/AreaDashboard";
import AddCustomerPage from "./components/AddCustomerPage";
import DailyEntryPage from "./components/DailyEntryPage";
import ReportsPage from "./components/ReportsPage";
import CustomerReport from "./components/CustomerReport";
import PreviousEntriesPage from "./components/PreviousEntriesPage"; // ✅ NEW IMPORT
import AreaProtectedRoute from "./components/AreaProtectedRoute";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import PrintableDailySheet from "./components/PrintableDailySheet";


export default function App() {
  return (
    <Routes>
      {/* 🔐 Login */}
      <Route path="/" element={<LoginPage />} />

      {/* 🔒 Protect Admin */}
      <Route
        path="/admin"
        element={
          <AdminProtectedRoute>
            <AdminDashboard />
          </AdminProtectedRoute>
        }
      />

      {/* 🔒 Protect Area Pages */}
      <Route
        path="/area/:slug"
        element={
          <AreaProtectedRoute>
            <AreaDashboard />
          </AreaProtectedRoute>
        }
      />
      <Route
        path="/area/:slug/add-customer"
        element={
          <AreaProtectedRoute>
            <AddCustomerPage />
          </AreaProtectedRoute>
        }
      />
      <Route
        path="/area/:slug/daily-entry"
        element={
          <AreaProtectedRoute>
            <DailyEntryPage />
          </AreaProtectedRoute>
        }
      />
      <Route
        path="/area/:slug/reports"
        element={
          <AreaProtectedRoute>
            <ReportsPage />
          </AreaProtectedRoute>
        }
      />
      <Route
        path="/area/:slug/report/:customerId"
        element={
          <AreaProtectedRoute>
            <CustomerReport />
          </AreaProtectedRoute>
        }
      />

      {/* ✅ NEW: Previous Entries Page */}
      <Route
        path="/area/:slug/previous-entries"
        element={
          <AreaProtectedRoute>
            <PreviousEntriesPage />
          </AreaProtectedRoute>
        }
      />
      <Route path="/area/:slug/print-sheet" element={<AreaProtectedRoute><PrintableDailySheet /> </AreaProtectedRoute>} />


      {/* Redirect unknown routes */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
